import PropTypes from 'prop-types';

export const institutionInviteProps = {
  _id: PropTypes.string.isRequired,
  institution_id: PropTypes.string.isRequired,

  email: PropTypes.string.isRequired,
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string.isRequired,

  created_on: PropTypes.string.isRequired,
  created_by: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    displayname: PropTypes.string.isRequired,
    gravatar: PropTypes.string.isRequired
  }).isRequired,

  activated_on: PropTypes.string,
  activated_by: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    displayname: PropTypes.string.isRequired,
    gravatar: PropTypes.string.isRequired
  })

};

export const institutionInvitePropType = PropTypes.shape(institutionInviteProps);

export const institutionInviteIsPending = inv => inv && !inv.activated_by;



// WEBPACK FOOTER //
// ./webAdmin/utils/invites.js